import React from "react";
import "./brandsLove.css";

const BrandsLove = () => {
  return (
    <div className="brands-love">
      <div className="max-width">
        <div className="brands-love-heading">our most credible associates come from.</div>
        <div className="brands-love-banner"></div>
      </div>
    </div>
  );
};

export default BrandsLove;
